import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import routes from "@constants/routes";

import contentCardStyles from "@theme/contentCardStyles";

import ResourceLink from "../ResourceLink";

interface ITableEmptyStateProperties {
  handleButtonClick?: () => void;
  heading: string;
  resourceLink: string;
  state: string;
  supportingText: string;
}

/**
 * This component renders text and buttons when a table is empty in the application.
 * @param  heading - The heading to display.
 * @param  supportingText - The supporting text to display.
 * @param  state - The empty state for which we are showing buttons.
 * @param  handleButtonClick - The function to call when the button is clicked.
 * @param  resourceLink - The link to the tutorial video.
 */
export default function TableEmptyState({
  handleButtonClick = () => {
    /* Do Nothing */
  },
  heading,
  resourceLink = "",
  state = "",
  supportingText,
}: ITableEmptyStateProperties) {
  const navigate = useNavigate();

  const handleIPSearchClick = () => {
    navigate(routes.EMBEDDING_SEARCH_COMPANIES);
  };

  const handleDirectoryClick = () => {
    navigate(routes.EMBEDDING_SEARCH_COMPANIES);
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        ...contentCardStyles,
      }}
    >
      <Typography variant="h4">{heading}</Typography>
      {resourceLink && <ResourceLink resourceLink={resourceLink} workflow={state} />}
      <Typography align="center" sx={{ mt: 0.5 }}>
        {supportingText}
      </Typography>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          gap: 2,
          justifyContent: "center",
          mt: 4,
        }}
      >
        {state === "campaigns" ? (
          <Button onClick={handleButtonClick} variant="contained">
            View Technology Contacts
          </Button>
        ) : (
          <>
            <Button onClick={handleDirectoryClick} variant="contained">
              Explore Directory
            </Button>
            <Button onClick={handleIPSearchClick} variant="contained">
              Smart Search
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}
